import { css } from "@emotion/react";

export const styles = {
  description: css`
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    color: #ffffff;
  `,
  partner: css`
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
  `,
  points: css`
    font-size: 24px;
    font-weight: 600;
    line-height: 33.6px;
    text-align: left;
    color: #ff8b00;
    margin-top: 8px;
  `,
  validity: css`
    font-size: 12px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: left;
    color: #ffffff;
    margin-top: 8px;
  `,
  validity_title: css`
    font-size: 12px;
    font-weight: 700;
    line-height: 16.8px;
    text-align: left;
    color: #ffffff;
  `,
  button: css`
    background-color: #0045b5;
    height: 48px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    border-radius: 6px;
    width: fit-content;
    align-self: center;
    &:hover {
      background-color: #003399;
    }
  `,
  tag: css`
    background-color: #ff8b00;
    height: 36.25px;
    padding: 8px 16px 8px 16px;
    gap: 10px;
    border-radius: 30px;
    border: 1px 0px 0px 0px;
    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    width: fit-content;
    gap: 10px;
    align-items: center;
  `
};
